import {Component, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {PlaneGuide} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-plane-guide-inspector",
    templateUrl: "./plane-guide-inspector.component.html",
    styleUrl: "./plane-guide-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class PlaneGuideInspectorComponent extends BaseInspectorComponent<PlaneGuide> {}
